<template><div><h1 id="qr-esr-rechnunsgparameter" tabindex="-1"><a class="header-anchor" href="#qr-esr-rechnunsgparameter"><span>QR-/ESR-Rechnunsgparameter</span></a></h1>
<p>QR-/ESR-Rechnunsgparameter — Stammtabelle für ESR Konto Informationen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient der Festlegung von QR-/ESR-Rechnunsgparameter, die für die Produktion von Einzahlungsscheinen (orange Einzahlungsscheine), QR-Rechnung und für die automatische Verarbeitung (Einlesen der Zahlungen) benötigt werden.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → QR-/ESR-Rechnunsgparameter</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>ESR-Code</dt>
<dd>ESR-Code, wird automatisch vom System vergeben.</dd>
<dt>ESR-Nummer</dt>
<dd>ESR-Teilnehmernummer, wird von der Bank/Post mitgeteilt. Sowohl für Post- als auch für Bankkonto wird eine ESR-Teilnehmernummer benötigt.</dd>
</dl>
<p>::: tipp Anmerkung
Das System validiert die ESR Nummer teilweise: Nummern, die mit &quot;01&quot; anfangen, brauchen ein &quot;CHF&quot;-Konto; Nummern, die mit &quot;03&quot; anfangen, benötigen ein &quot;EUR&quot;-Konto.
:::</p>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Die Prüfziffer der ESR-Nummer wird nicht geprüft.</p>
</div>
<dl>
<dt>BESR-ID</dt>
<dd>BESR-ID, wird von der Bank mitgeteilt. Für Bankkonto wird eine BESR-ID zusammen mit der ESR-Teilnehmernummer benötigt.</dd>
<dt>Mandant</dt>
<dd>Mandant, für den die ESR-Teilnehmernummer gilt.</dd>
<dt>Konto</dt>
<dd>Konto für die Zahlung. Dieses Konto wird beim Erfassen einer Spende anhand des Ereignisses aus der Tabelle <a class="link" href="ft.refdata.tblereigesrverk.html" title="Ereignis-ESR-Nummerverknüpfungen">Ereignis-ESR-Nummerverknüpfungen</a> vorgeschlagen.</dd>
<dt>Kst</dt>
<dd>Kostenstelle für die Zahlung.</dd>
<dt>Ktr</dt>
<dd>Kostenträger für die Zahlung.</dd>
<dt>Verwendung</dt>
<dd>Freier Text zur Bezeichnung der ESR-Teilnehmernummer.</dd>
<dt>IID</dt>
<dd>IID &quot;Instituts-Identifikation&quot;, ehemalige Clearingnummer.</dd>
<dt>IBAN</dt>
<dd>IBAN-Nummer, für die Definition des Kontos. Wird von der Bank bzw. Post mitgeteilt.</dd>
<dt>Ereignis und Ereignisposition</dt>
<dd>Für Zahlungen die nicht zugeordnet werden können. Die Zahlung wird auf das definierte Spendenereignis verbucht. Wenn kein Ereignis definiert ist, entsteht ein Guthaben.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblereigesrverk.html" title="Ereignis-ESR-Nummerverknüpfungen">Ereignis-ESR-Nummerverknüpfungen</RouteLink>, <RouteLink to="/manual/buchhaltung/debitorenverwaltung.html#Debitorenverwaltung" title="1. Debitorenverwaltung">Buchhaltung</RouteLink></p>
</div></template>


